import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CollectEmailComponent } from "@app/shared-components/collect-email/collect-email.component";

@Component({
  selector: 'email-subscribe',
  standalone: true,
  imports: [CollectEmailComponent],
  templateUrl: './email-subscribe.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./email-subscribe.component.css'],
})
export class EmailSubscribeComponent {
  public title = "Subscribe to Outdoor Access Emails";
  public buttonText = "Subscribe Now";
  public initialEmail?: string;

  constructor(private route: ActivatedRoute) {
    this.route.queryParamMap.subscribe(params => {
      const email = params.get('email');
      if (email) {
        this.initialEmail = email;
      }
    });
  }

  submitted() {
    // handle submit event
  }
  completed() {
    // handle completed event
  }
}
